var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"bg-black opacity-50 fixed w-full h-full z-overlay top-0 left-0",on:{"click":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }